import { CHARGING_STATION_OPERATIONAL_STATUS, CHARGING_STATION_PLUG_TYPE } from '../../enums/model.enums';
import { MetaData } from '../MetaData';
/**
 * class {ChargingStationConnector}
 * should be used to represent a ChargingStationConnector
 */
export class ChargingStationConnector extends MetaData {
    /**
     * constructor of class
     * please use factory instead
     * @param connectorTitle
     * @param connectorFormalName
     * @param plugType
     * @param operationalStatus
     * @param powerKw
     * @param voltage
     * @param amps
     * @param ampsMin
     * @param quantity
     * @param spaceID
     * @param inUse
     * @param metaData
     */
    constructor(connectorTitle, connectorFormalName, plugType, operationalStatus, powerKw, voltage, amps, ampsMin, quantity, spaceID, inUse, metaData) {
        super(metaData);
        this._connectorTitle = connectorTitle;
        this._connectorFormalName = connectorFormalName;
        this._plugType = plugType;
        this._operationalStatus = operationalStatus;
        this._powerKw = powerKw;
        this._voltage = voltage;
        this._amps = amps;
        this._ampsMin = ampsMin;
        this._quantity = quantity;
        this._spaceID = spaceID;
        this._inUse = inUse;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {ChargingStationConnector}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.connectorTitle = values.connectorTitle !== undefined ? values.connectorTitle : '';
        sanitizedValues.connectorFormalName = values.connectorFormalName !== undefined ? values.connectorFormalName : '';
        sanitizedValues.plugType = values.plugType !== undefined ? values.plugType : CHARGING_STATION_PLUG_TYPE.UNKNOWN;
        sanitizedValues.operationalStatus = values.operationalStatus !== undefined ?
            values.operationalStatus : CHARGING_STATION_OPERATIONAL_STATUS.NO_INFO;
        sanitizedValues.powerKw = values.powerKw !== undefined ? values.powerKw : 0;
        sanitizedValues.voltage = values.voltage !== undefined ? values.voltage : 0;
        sanitizedValues.amps = values.amps !== undefined ? values.amps : 0;
        sanitizedValues.ampsMin = values.ampsMin !== undefined ? values.ampsMin : 0;
        sanitizedValues.quantity = values.quantity !== undefined ? values.quantity : 0;
        sanitizedValues.spaceID = values.spaceID !== undefined ? values.spaceID : '';
        sanitizedValues.inUse = values.inUse !== undefined ? values.inUse : false;
        sanitizedValues.metaData = values.metaData !== undefined ? values.metaData : {};
        return new ChargingStationConnector(sanitizedValues.connectorTitle, sanitizedValues.connectorFormalName, sanitizedValues.plugType, sanitizedValues.operationalStatus, sanitizedValues.powerKw, sanitizedValues.voltage, sanitizedValues.amps, sanitizedValues.ampsMin, sanitizedValues.quantity, sanitizedValues.spaceID, sanitizedValues.inUse, sanitizedValues.metaData);
    }
    /**
     * get the connectorTitle for this charging station connector
     * @returns {string}
     */
    get connectorTitle() {
        return this._connectorTitle;
    }
    /**
     * set the connectorTitle
     * @param value
     */
    set connectorTitle(value) {
        this._connectorTitle = value;
    }
    /**
     * get the connectorFormalName
     * @returns string
     */
    get connectorFormalName() {
        return this._connectorFormalName;
    }
    /**
     * set the connectorFormalName
     * @param value
     */
    set connectorFormalName(value) {
        this._connectorFormalName = value;
    }
    /**
     * get the plugType
     * @returns CHARGING_STATION_PLUG_TYPE
     */
    get plugType() {
        return this._plugType;
    }
    /**
     * set the plugType
     * @param value
     */
    set plugType(value) {
        this._plugType = value;
    }
    /**
     * get the operationalStatus
     * @returns CHARGING_STATION_OPERATIONAL_STATUS
     */
    get operationalStatus() {
        return this._operationalStatus;
    }
    /**
     * set the operationalStatus
     * @param value
     */
    set operationalStatus(value) {
        this._operationalStatus = value;
    }
    /**
     * get the powerKw
     * @returns number
     */
    get powerKw() {
        return this._powerKw;
    }
    /**
     * set the powerKw
     * @param value
     */
    set powerKw(value) {
        this._powerKw = value;
    }
    /**
     * get the voltage
     * @returns number
     */
    get voltage() {
        return this._voltage;
    }
    /**
     * set the voltage
     * @param value
     */
    set voltage(value) {
        this._voltage = value;
    }
    /**
     * get the amps
     * @returns number
     */
    get amps() {
        return this._amps;
    }
    /**
     * set the amps
     * @param value
     */
    set amps(value) {
        this._amps = value;
    }
    /**
     * get the minimum amps
     * @returns number
     */
    get ampsMin() {
        return this._ampsMin;
    }
    /**
     * set the minimum amps
     * @param value
     */
    set ampsMin(value) {
        this._ampsMin = value;
    }
    /**
     * get the quantity
     * @returns number
     */
    get quantity() {
        return this._quantity;
    }
    /**
     * set the quantity
     * @param value
     */
    set quantity(value) {
        this.quantity = value;
    }
    /**
     * get the space ID
     * @returns number
     */
    get spaceID() {
        return this._spaceID;
    }
    /**
     * set the space ID
     * @param value
     */
    set spaceID(value) {
        this._spaceID = value;
    }
    /**
     * get usage information
     * @returns number
     */
    get inUse() {
        return this._inUse;
    }
    /**
     * set usage information
     * @param value
     */
    set inUse(value) {
        this._inUse = value;
    }
}
//# sourceMappingURL=chargingStationConnector.js.map